import { Box, Grid } from '@material-ui/core';
import { AccessTime, Assignment, CalendarToday, CheckCircleOutline, PeopleOutline, TrendingUp } from '@material-ui/icons';
import { StatCard } from '../student-dashboard/stat-card';
import { useStyles } from './styles';

function StatIcon({ Icon }) {
  const classes = useStyles();
  return (
    <Box className={classes.statCardIconBox}>
      <Icon className={classes.statCardIcon} />
    </Box>
  );
}

export function StatCardsRow({ activeCount, closedCount, participationsCount, averageGrade }) {
  const classes = useStyles();
  console.log(activeCount)
  return (
    <Grid container spacing={2} className={classes.statCardsRow}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={CalendarToday} />}
          title="Avaliações Ativas"
          value={activeCount}
          label="Disponíveis para realização"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={AccessTime} />}
          title="Encerradas"
          value={closedCount}
          label="Histórico de avaliações"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={PeopleOutline} />}
          title="Participações"
          value={participationsCount}
          label="Tentativas registradas"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={TrendingUp} />}
          title="Média Geral"
          value={averageGrade}
          label="Desempenho médio dos alunos"
        />
      </Grid>
    </Grid>
  );
}

export function PrintedStatCardsRow({ createdCount, correctedCount, pendingCount, averageGrade }) {
  const classes = useStyles();

  return (
    <Grid container spacing={2} className={classes.statCardsRow}>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={Assignment} />}
          title="Avaliações Criadas"
          value={createdCount}
          label="Total de avaliações impressas"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={CheckCircleOutline} />}
          title="Corrigidas"
          value={correctedCount}
          label="Avaliações já corrigidas"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={AccessTime} />}
          title="Pendentes de Correção"
          value={pendingCount}
          label="Aguardando leitura"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <StatCard
          icon={<StatIcon Icon={TrendingUp} />}
          title="Média da Turma"
          value={averageGrade}
          label="Média geral dos resultados"
        />
      </Grid>
    </Grid>
  );
}